/**
 * 审批中心 - 路由转发页面
 * 
 * 为了保持向后兼容，此页面将 /approvals 路由转发到新的位置
 * 实际实现已移至 (modules)/approval-center
 * 
 * 注意: (modules) 是路由组，不影响URL，所以 (modules)/approval-center 对应 /approval-center
 */

'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

export default function ApprovalsRedirect() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    // 保留所有查询参数
    const params = searchParams.toString();
    const newPath = params ? `/approval-center?${params}` : '/approval-center';
    router.replace(newPath);
  }, [router, searchParams]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">正在跳转到审批中心...</p>
      </div>
    </div>
  );
}
